import type { OrchestratorSchemas } from '@ctcells/contract'

import { orchestrator } from '../clients.ts'
import { keys } from '../keys.ts'
import { createQuery, type SkippableArgs } from '../query.ts'

/**
 * 알림 수신자 목록 — `GET /settings/alarm-recipients`(`IFC-RO-103` · v0.9.4 · 정본 `07` §4.7 «알림 수신자»).
 *
 * 실물(`ctcells-core/app/views/alarm_recipients.py` · core@d50b8cf4)
 *
 * | 칸 | 값 |
 * | --- | --- |
 * | 역할 | **admin 한정**(`ALLOWED_ROLES`) — operator · viewer 는 403. 제어락 비대상 |
 * | 응답 | `AlarmRecipient[]` — **맨 배열**이다(`Page` 봉투가 아니다). 쪽 나눔 없음 |
 * | 주소 | 🔴 **싣지 않는다** — `url_set`(있는가)만 온다. 주소는 쓰기 전용 |
 * | 빈 칸 | `exclude_none` — `sources` · `error_codes` 가 `null`(= 전부)이면 **키째 없다**. 읽는 쪽은 `== null` 로 «전부» |
 *
 * 🔴 **admin 이 아니면 부르지 않는다**(`skip`) — 403 이 날 요청을 보내 「못 봤다」를 만들지 않는다. 컨테이너가 접근으로 가른다.
 * 🔴 주기 폴링 없다 — 스냅샷 1회 + 쓰기 뒤 무효화(`keys.alarmRecipients.all()`).
 */
export type AlarmRecipient = OrchestratorSchemas['schemas']['AlarmRecipient']
export type AlarmRecipientWrite = OrchestratorSchemas['schemas']['AlarmRecipientWrite']
export type AlarmRecipientTestResult = OrchestratorSchemas['schemas']['AlarmRecipientTestResult']

export const useAlarmRecipients = createQuery<SkippableArgs | void, AlarmRecipient[]>({
  key: () => keys.alarmRecipients.list(),
  fetch: () =>
    orchestrator.request<AlarmRecipient[]>({
      method: 'GET',
      path: '/settings/alarm-recipients',
      retryOn401: true,
    }),
})
